import React from 'react';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  type: 'info' | 'success' | 'warning' | 'error';
};

const ToastMessage = ({ children, type }: Props) => {
  let icon = null;
  const iconSize = 24;
  switch (type) {
    case 'info':
      icon = <S.Info size={iconSize} />;
      break;
    case 'success':
      icon = <S.Check size={iconSize} />;
      break;
    case 'warning':
    case 'error':
      icon = <S.Warning size={iconSize} />;
      break;
    default:
  }

  return (
    <S.Message>
      {icon}
      {children}
    </S.Message>
  );
};

export default ToastMessage;
